// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/faq`;

export const GetFaqListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "list" }),
    });

    if (!response.ok) throw new Error("Failed to fetch faq list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteFaq = async (faqId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this FAQ?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "delete", _id: faqId }),
      });

      const data = await response.json();
      if (data.success) toast.success("FAQ deleted successfully");
      else toast.warning("FAQ deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitFaqApi = async (recipeData) => {
  try {
    const faqpaylode = { 
      action: recipeData._id ? "edit" : "add",
      _id: recipeData._id,
      question: recipeData.question,
      answer: recipeData.answer,
    };
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: faqpaylode ? JSON.stringify(faqpaylode) : null,
    });


    // const response = await fetch(url, { method: "POST", body: formData });
    const result = await response.json();

    if (result.success || response.status === 201) {
      toast.success(recipeData._id ? "FAQ updated successfully" : "FAQ added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save FAQ");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the FAQ");
    return null;
  }
};

export const getFaqByIdApi = async (id) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({action: "getById", _id: id}),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load recipe");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
